module.exports = __webpack_public_path__ + "static/media/Singapore.e9efce2a.svg";